module.exports = __webpack_public_path__ + "img/247.2ab1b989.jpg";